var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("table", { staticClass: "table mt-1 table-sm table-hover" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.sortArray(_vm.records, "name"), function (c) {
              return _c("tr", { key: c.id }, [
                _c("td", [
                  _vm._v(_vm._s(c.name) + " (" + _vm._s(c.title) + ")"),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(c.currency))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(c.settings))]),
                _vm._v(" "),
                _c("td"),
              ])
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", [_vm._v("Страны поставщиков")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("Страна")]),
        _vm._v(" "),
        _c("th", [_vm._v("Доставка")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }